import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const OrderCompleteContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const offset = 2;

  const [total_order, setTotal_order] = useState(0);
  const [order_list, setOrder_list] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  const lastOrderDetailRequestKey = useRef(null);

  const getOrderDetail = async () => {
    try {
      const body = {
        page,
        offset,
        paymentId: location.state?.paymentId,
      };

      const res = await postJson("/dashboard/gifticonOrder/getDetail", body, navigate);
      if (res.code === 200) {
        setTotal_order(res.data.count);
        setOrder_list(res.data.rows);
        setOrderInfo(res.data.orderInfo);
      }
    } catch (error) {
      console.error("주문정보 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({
      page,
      paymentId: location.state?.paymentId,
    });

    if (lastOrderDetailRequestKey.current === requestKey) {
      return;
    }

    lastOrderDetailRequestKey.current = requestKey;
    getOrderDetail();
  }, [page, location.state?.paymentId]);

  return (
    <div>
      <PushApplyBox>
        <div style={{ justifyItems: "center" }}>
          <div className="title-in-box">주문이 완료되었습니다.</div>
          <div style={{ marginTop: "20px", display: "flex" }}>
            <p
              className="bold-text"
              style={{ fontSize: "24px", color: "#1167ed" }}
            >
              {orderInfo.transferLimitTime}
            </p>
            <p style={{ fontSize: "24px", color: "#222222" }}>
              &nbsp;까지 입금을 완료해주세요.
            </p>
          </div>
          <p style={{ color: "#222222", marginTop: "20px" }}>
            관리자의 입금 확인 처리 이후 보관함에서 기프티콘을 이용하실 수
            있습니다.
          </p>
        </div>

        <div
          className="bold-text"
          style={{ marginTop: "30px", marginBottom: "8px", fontSize: "18px" }}
        >
          주문 상품
        </div>
        <div
          className="list_titleBar"
          style={{
            width: "735px",
            height: "44px",
            gridTemplateColumns: "44px 300px 140px 251px",
          }}
        >
          <div />
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            기프티콘
          </p>
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문 수량
          </p>
          <p
            className="leftalign medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문 금액
          </p>
        </div>
        {order_list.map((data) => (
          <ListItem
            image={data.goodsImgS}
            name={data.goodsName}
            quantity={data.quantity}
            cost={data.totalAmount}
          />
        ))}

        <Pagination
          totalPages={total_order === 0 ? 1 : Math.ceil(total_order / 2)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />

        <div
          className="bold-text"
          style={{ marginTop: "40px", fontSize: "18px" }}
        >
          총 결제 금액
        </div>

        <div
          className="medium-text"
          style={{ color: "#222222", marginTop: "14px" }}
        >
          {orderInfo.totalAmount?.toLocaleString()}원
        </div>

        <div
          className="bold-text"
          style={{ marginTop: "40px", fontSize: "18px" }}
        >
          결제 수단
        </div>
        <div style={{ display: "flex", marginTop: "14px" }}>
          <div style={{ color: "#222222" }}>
            {orderInfo.payMethod === "trans"
              ? "무통장입금"
              : orderInfo.payMethod === "card"
              ? "신용카드"
              : "가상계좌"}
          </div>
        </div>

        <div style={{ color: "#f25c5c", marginTop: "6px" }}>
          *주문 후 72시간 내 미입금시 주문 자동 취소
        </div>

        <div
          className="grayBox"
          style={{ marginTop: "14px", padding: "30px", borderRadius: "20px" }}
        >
          <p className="bold-text">입금 정보</p>
          <p style={{ marginTop: "14px" }}>
            입금처 : 농협은행 / 301-0327-0214-21 / 주식회사 러닝포인트
          </p>
          <div style={{ display: "flex", marginTop: "14px" }}>
            <p style={{ color: "#555555" }}>입금 기한</p>
            <p className="medium-text" style={{ marginLeft: "auto" }}>
              {orderInfo.transferLimitTime}
            </p>
          </div>
          <div style={{ display: "flex", marginTop: "14px" }}>
            <p style={{ color: "#555555" }}>입금자명</p>
            <p className="medium-text" style={{ marginLeft: "auto" }}>
              {orderInfo.transferUsername}
            </p>
          </div>
          <hr
            color="#e4e4e4"
            style={{
              margin: "30px 0",
              border: 0,
              height: "1px",
            }}
          />
          <p className="bold-text">현금영수증 정보</p>

          <div style={{ display: "flex", marginTop: "14px" }}>
            <p style={{ color: "#555555" }}>사업자번호</p>
            <p className="medium-text" style={{ marginLeft: "auto" }}>
              {orderInfo.cashNo}
            </p>
          </div>
          <div style={{ display: "flex", marginTop: "14px" }}>
            <p style={{ color: "#555555" }}>발급 이메일</p>
            <p className="medium-text" style={{ marginLeft: "auto" }}>
              {orderInfo.cashEmail}
            </p>
          </div>
        </div>

        <div
          style={{ justifySelf: "center", marginTop: "40px", display: "flex" }}
        >
          <div
            className="blueBorderBtn-base center"
            style={{ width: "280px", height: "60px", borderRadius: "10px" }}
            onClick={() => navigate("/gifticon")}
          >
            쇼핑 계속하기
          </div>
          <div
            className="blueBtn-base"
            style={{
              marginLeft: "8px",
              width: "280px",
              height: "60px",
              borderRadius: "10px",
            }}
            onClick={() =>
              navigate("/company", {
                state: { gifticonClick: true, orderClick: true },
              })
            }
          >
            주문 내역 확인
          </div>
        </div>
      </PushApplyBox>
    </div>
  );
};

const ListItem = ({ image, name, quantity, cost }) => {
  return (
    <div
      className="list_contentBar"
      style={{
        width: "735px",
        height: "61px",
        gridTemplateColumns: "44px 300px 140px 251px",
      }}
    >
      <div className="center">
        <div style={{ width: "44px", height: "44px" }}>
          <img src={image} style={{ width: "100%", height: "100%" }} />
        </div>
      </div>
      <p className="leftalign">{name}</p>
      <p className="leftalign">{quantity?.toLocaleString()}개</p>
      <p className="leftalign">{cost?.toLocaleString()}원</p>
    </div>
  );
};

const InputBox = ({ placeholder, handleValue }) => {
  return (
    <div
      style={{
        padding: "16px 14px",
        boxShadow: "inset 0 0 0 1px #e4e4e4",
        borderRadius: "10px",
      }}
    >
      <input
        type="text"
        className="textinput"
        style={{ width: "703px", height: "21px" }}
        placeholder={placeholder}
        onChange={(e) => handleValue(e.target.value)}
      />
    </div>
  );
};

const PushApplyBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  margin-left: 413px;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #ffffff;
`;

const OrderComplete = () => {
  return <Layout page={<OrderCompleteContent />} />;
};

export default OrderComplete;
